'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../../core/index.js');
var text = require('../../components/text.js');
require('../../components/index.js');
var device = require('../../utils/device.js');
var colors = require('../../theme/veho/colors.js');
var collapsible = require('./collapsible.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  ", " {\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 24px;\n\n  ", " {\n    display: inline-block;\n    font-size: 24px;\n    line-height: 1;\n    margin-right: 12px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  position: relative;\n  min-height: 1px;\n  padding: 0 12px;\n  ", " {\n    width: 25%;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  position: relative;\n  margin: 8px 0;\n\n  input {\n    display: block;\n    width: 100%;\n    outline: 0 none;\n    background-color: #333333;\n    border: 1px solid #333333;\n    border-radius: 3px;\n    padding: 8px 52px 8px 10px;\n    color: rgba(255, 255, 255, 0.66);\n    font-size: ", ";\n    margin: 0;\n\n    &:focus {\n      box-shadow: none;\n    }\n    &:focus + button {\n      opacity: 1;\n    }\n    &::-webkit-input-placeholder {\n      color: rgba(255, 255, 255, 0.66);\n    }\n    &:-moz-placeholder {\n      color: rgba(255, 255, 255, 0.66);\n    }\n    &::-moz-placeholder {\n      color: rgba(255, 255, 255, 0.66);\n    }\n    &:-ms-input-placeholder {\n      color: rgba(255, 255, 255, 0.66);\n    }\n  }\n\n  button {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 42px;\n    height: 42px;\n    color: #ffffff;\n    padding: 9px 12px;\n    border-radius: 0 3px 3px 0;\n\n    &:hover,\n    &:focus {\n      opacity: 1;\n    }\n  }\n\n  ", "\n\n  span {\n    color: ", ";\n    opacity: ", ";\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: #ffffff;\n  margin: 0;\n\n  &:after {\n    content: '.';\n    display: inline-block;\n    line-height: 1;\n    vertical-align: text-top;\n    margin: 0px 8px;\n  }\n  ", " {\n    display: flex;\n    flex-direction: column;\n    margin-top: 6px;\n    color: #ffffff;\n    font-size: 16px;\n    line-height: 24px;\n    &:hover {\n      color: rgba(255, 255, 255, 0.7);\n    }\n    &:after {\n      content: '';\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: table;\n  margin-top: 6px;\n\n  ", " {\n    &:hover {\n      color: rgba(255, 255, 255, 0.7);\n    }\n  }\n\n  i {\n    vertical-align: middle;\n    margin-right: 8px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  border-color: #292929;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 40px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 32px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 146px;\n  position: absolute;\n  padding: 1% 10%;\n  width: 100%;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: 24px;\n\n  h6 {\n    margin: 0 0 4px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 24px;\n  color: #888888;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FooterHeading = styled__default['default'].h6(_templateObject(), '600', '16px');
var InnerWrapper = styled__default['default'].div(_templateObject2(), index.styleEngine); // FOOTER CONTAINER

var SiteFooter = styled__default['default'].footer(_templateObject3(), colors['default'].black, colors['default'].white, '16px'); // THEMED LINKS

var FooterThemes = styled__default['default'].div(_templateObject4()); // STATIC LINKS

var FooterStaticLinks = styled__default['default'].section(_templateObject5()); // ACCORDION

var FooterAccordion = styled__default['default'].section(_templateObject6());
var Separator = styled__default['default'].hr(_templateObject7());
var Link = styled__default['default'](text['default']).attrs({
  as: 'a'
})(_templateObject8(), colors['default'].white, device.above('tablet'));
var FooterLink = styled__default['default'].a(_templateObject9(), device.above('mobile'));
var TextBox = styled__default['default'].div(_templateObject10(), '16px', function (props) {
  return props.tboxState === 'has-error' ? " \n  input {\n    border-color: #f44336;\n  }\n  button {\n    opacity: 1;\n    background-color: #f44336;\n    border-color: #f44336;\n  }\n  " : '';
}, colors['default'].green['04'], function (props) {
  return props.tboxState === 'success' ? '1' : '0';
});
var Column = styled__default['default'].div(_templateObject11(), device.above('tablet'));
var Socials = styled__default['default'].span(_templateObject12(), Link);
var FooterColumn = styled__default['default'].div(_templateObject13(), device.above('mobile'));

var is_server = function is_server() {
  return !(typeof window !== 'undefined' && window.document);
};

var isMobile = function isMobile() {
  if (!is_server()) {
    return window.innerWidth <= 991;
  }

  return false;
};

var _MOBILE = isMobile();

var Footer = function Footer(_ref) {
  var _ref$footerData = _ref.footerData,
      footerData = _ref$footerData === void 0 ? [] : _ref$footerData,
      actions = _ref.actions,
      openChatWidget = _ref.openChatWidget,
      showContactNumber = _ref.showContactNumber,
      pathname = _ref.pathname,
      helpers = _ref.helpers,
      appConfig = _ref.appConfig,
      DotList = _ref.DotList,
      trackers = _ref.trackers,
      handlers = _ref.handlers,
      hideEmailForm = _ref.hideEmailForm;

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      tboxState = _useState4[0],
      setTboxState = _useState4[1];

  React.useEffect(function () {
    // if footer data is not avaible the hitting the api to get the data
    !footerData.length && (actions === null || actions === void 0 ? void 0 : actions.fetchFooterData());
  }, []);

  var onTriggerClick = function onTriggerClick(index) {
    if (expanded === index) {
      index = '';
    }

    setExpanded(index);
  };

  var FooterPYTLinks = /*#__PURE__*/React__default['default'].createElement(FooterColumn, null, /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/about-us",
    className: trackers.ABOUT,
    onClick: handlers.scrollTop
  }, "About Us"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/careers",
    className: trackers.CAREERS,
    onClick: handlers.scrollTop
  }, "Careers"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/blog/?cpid=footer",
    className: trackers.BLOG
  }, "Blog"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/testimonials",
    className: trackers.TESTIMONIALS,
    onClick: handlers.scrollTop
  }, "Testimonials"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    href: "https://pickyourtrail.com/guides",
    target: '_blank',
    rel: "noopener noreferrer",
    className: trackers.GUIDES
  }, "Guides"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://visa.pickyourtrail.com/",
    className: trackers.VISA
  }, "Visa"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/press",
    className: trackers.PRESS,
    onClick: handlers.scrollTop
  }, "Press"));
  var FooterPolicyLinks = /*#__PURE__*/React__default['default'].createElement(FooterColumn, null, /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    key: 'footerFaqBtn',
    href: "/faq",
    onClick: function onClick() {
      return handlers.scrollTop(undefined, true);
    },
    className: trackers.FAQ
  }, "Frequently Asked Questions"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    key: 'footerTermsBtn',
    href: "/terms-and-conditions",
    onClick: function onClick() {
      return handlers.scrollTop(undefined, true);
    },
    className: trackers.termTERMS
  }, "Terms & Conditions"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    key: 'footerPrivacyBtn',
    href: "/privacy-policy",
    className: trackers.PRIVACY,
    onClick: function onClick() {
      return handlers.scrollTop(undefined, true);
    }
  }, "Privacy"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    key: 'footerCancellationBtn',
    href: "/cancellation-policy",
    className: trackers.CANCELLATIONS,
    onClick: function onClick() {
      return handlers.scrollTop(undefined, true);
    }
  }, "Cancellations"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/all",
    className: trackers.SITEMAP,
    onClick: handlers.scrollTop
  }, "Sitemap"), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://pickyourtrail.com/contact-us",
    className: trackers.CONTACT_US,
    onClick: handlers.scrollTop
  }, "Contact Us"));

  var FooterCopyRights = function FooterCopyRights(_ref2) {
    var pathname = _ref2.pathname;
    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Socials, {
      itemScope: true,
      itemType: "http://schema.org/Organization"
    }, /*#__PURE__*/React__default['default'].createElement(FooterLink, {
      itemProp: "sameAs",
      href: "https://www.facebook.com/pg/Pickyourtrail/reviews/",
      target: "_blank",
      rel: "noopener noreferrer nofollow",
      className: trackers.FACEBOOK
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: "pyt-facebook-16"
    })), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
      itemProp: "sameAs",
      href: "https://twitter.com/@pickyourtrail",
      target: "_blank",
      rel: "noopener noreferrer nofollow",
      className: trackers.TWITTER
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: "pyt-twitter-16"
    })), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
      itemProp: "sameAs",
      href: "https://www.instagram.com/pickyourtrail/",
      target: "_blank",
      rel: "noopener noreferrer nofollow",
      className: trackers.INSTAGRAM
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: "pyt-instagram-16"
    })), /*#__PURE__*/React__default['default'].createElement(FooterLink, {
      itemProp: "sameAs",
      href: "https://in.linkedin.com/company/pickyourtrail",
      target: "_blank",
      rel: "noopener noreferrer nofollow",
      className: trackers.LINKEDIN
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: "pyt-linkedin-16"
    }))), /*#__PURE__*/React__default['default'].createElement(text['default'], {
      marginBottom: "0"
    }, "Travel Troops Global Private Ltd.", /*#__PURE__*/React__default['default'].createElement("br", null), "\xA9 ", new Date().getFullYear(), " all rights reserved.", pathname === "/".concat(helpers.MALDIVES_ROUTES.LANDING_PAGE_KEY) && '| For details +91 9884529921'));
  };

  var IS_SERVER = is_server();

  if (!IS_SERVER && localStorage.getItem('show_combined_logo') === true || !IS_SERVER && localStorage.getItem('show_combined_logo') === 'true') {
    return '';
  }

  var ENABLE_CONTACT_NUMBER = showContactNumber || appConfig.enable_Contact_Number;
  return /*#__PURE__*/React__default['default'].createElement(SiteFooter, {
    className: "site-footer"
  }, /*#__PURE__*/React__default['default'].createElement(InnerWrapper, {
    className: "container lg-container"
  }, !_MOBILE ? /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("section", {
    className: "clearfix fw pbottom-large"
  }, footerData.map(function (categoryItem, ca_index) {
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(FooterThemes, {
      key: "category_key_".concat(ca_index)
    }, /*#__PURE__*/React__default['default'].createElement(FooterHeading, null, categoryItem.category), /*#__PURE__*/React__default['default'].createElement(DotList, {
      options: categoryItem.destinations,
      ca_index: ca_index,
      onClickLink: handlers.scrollTop
    })), /*#__PURE__*/React__default['default'].createElement(Separator, {
      className: "clearfix fw"
    }));
  })), /*#__PURE__*/React__default['default'].createElement(FooterStaticLinks, {
    className: "row"
  }, /*#__PURE__*/React__default['default'].createElement(Column, null, /*#__PURE__*/React__default['default'].createElement(FooterHeading, null, "Pickyourtrail"), FooterPYTLinks), /*#__PURE__*/React__default['default'].createElement(Column, null, /*#__PURE__*/React__default['default'].createElement(FooterHeading, null, "Policy"), FooterPolicyLinks), /*#__PURE__*/React__default['default'].createElement(Column, null, /*#__PURE__*/React__default['default'].createElement(FooterHeading, null, "Talk to us"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(trackers.TALK_TO_AN_EXPERT, " mbottom-large")
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "mailto:planners@pickyourtrail.com"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "pyt-email-16"
  }), "planners@pickyourtrail.com"), ENABLE_CONTACT_NUMBER ? /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "tel: ".concat(helpers.getWebsiteContactNumber())
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "pyt-phone-16"
  }), helpers.getWebsiteContactNumber()) : null, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: "https://wa.me/+917806805380"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "pyt-whatsapp-16"
  }), "+917806805380")), hideEmailForm ? null : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(FooterHeading, null, "Sign up for travel ideas!"), /*#__PURE__*/React__default['default'].createElement(TextBox, {
    tboxState: tboxState
  }, /*#__PURE__*/React__default['default'].createElement("form", null, /*#__PURE__*/React__default['default'].createElement("input", {
    onChange: handlers.handleChange,
    id: "ftrEmailInput",
    type: "email",
    placeholder: "Your email"
  }), /*#__PURE__*/React__default['default'].createElement("button", {
    type: "submit",
    className: "btn btn-primary",
    onClick: function onClick(e) {
      return handlers.handleEmailSubmit(e, setTboxState);
    },
    id: "ftrEmailBtn"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "pyt-tickmark-16"
  }))), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "fine-text"
  }, "Thank you! We will keep you posted")))), /*#__PURE__*/React__default['default'].createElement(Column, null, /*#__PURE__*/React__default['default'].createElement(FooterHeading, null, "Social"), /*#__PURE__*/React__default['default'].createElement(FooterCopyRights, {
    pathname: pathname
  })))) : /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(FooterAccordion, {
    className: "panel-group",
    id: "footer-accordion"
  }, /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, footerData.map(function (categoryItem, ca_index) {
    return /*#__PURE__*/React__default['default'].createElement(FooterCollapse, {
      index: ca_index,
      expanded: expanded,
      onTriggerClick: onTriggerClick,
      trigger: /*#__PURE__*/React__default['default'].createElement(FooterHeading, {
        as: "span"
      }, categoryItem.category),
      key: "category_key_".concat(ca_index)
    }, /*#__PURE__*/React__default['default'].createElement(DotList, {
      options: categoryItem.destinations,
      ca_index: ca_index,
      onClickLink: handlers.scrollTop
    }));
  }), /*#__PURE__*/React__default['default'].createElement(FooterCollapse, {
    index: footerData.length + 1,
    expanded: expanded,
    onTriggerClick: onTriggerClick,
    trigger: /*#__PURE__*/React__default['default'].createElement(FooterHeading, {
      as: "span"
    }, "Pickyourtrail"),
    key: "category_key_".concat(footerData.length + 1)
  }, FooterPYTLinks), /*#__PURE__*/React__default['default'].createElement(FooterCollapse, {
    index: footerData.length + 2,
    expanded: expanded,
    onTriggerClick: onTriggerClick,
    trigger: /*#__PURE__*/React__default['default'].createElement(FooterHeading, {
      as: "span"
    }, "Policy"),
    key: "category_key_".concat(footerData.length + 2)
  }, FooterPolicyLinks))), /*#__PURE__*/React__default['default'].createElement("section", {
    className: "clearfix fw text-center"
  }, /*#__PURE__*/React__default['default'].createElement(FooterCopyRights, {
    pathname: pathname
  })))));
};

var FooterCollapse = function FooterCollapse(props) {
  return /*#__PURE__*/React__default['default'].createElement(collapsible['default'], {
    open: props.expanded === props.index,
    handleTriggerClick: function handleTriggerClick() {
      return props.onTriggerClick(props.index);
    },
    trigger: props.trigger
  }, props.children);
};

Footer.propTypes = {
  footerData: PropTypes__default['default'].array,
  actions: PropTypes__default['default'].object,
  openChatWidget: PropTypes__default['default'].func,
  showContactNumber: PropTypes__default['default'].number,
  pathname: PropTypes__default['default'].string,
  DotList: PropTypes__default['default'].node,
  appConfig: PropTypes__default['default'].object,
  trackers: PropTypes__default['default'].object,
  handlers: PropTypes__default['default'].object,
  helpers: PropTypes__default['default'].object
};
FooterCollapse.propTypes = {
  expanded: PropTypes__default['default'].number,
  index: PropTypes__default['default'].number,
  onTriggerClick: PropTypes__default['default'].func,
  trigger: PropTypes__default['default'].object,
  children: PropTypes__default['default'].element
}; // FooterCopyRights.propTypes = {

exports.default = Footer;
